var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtidotTextWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 37,
    viewBox: "0 0 137 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3328 0L0 36.1844H4.17062L16.1538 5.93283L28.137 36.1844H32.3076L32.0139 35.4795L17.9748 0H14.3328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1542 26.7271C17.9385 26.7271 19.3849 25.2807 19.3849 23.4964C19.3849 21.7121 17.9385 20.2656 16.1542 20.2656C14.3698 20.2656 12.9233 21.7121 12.9233 23.4964C12.9233 25.2807 14.3698 26.7271 16.1542 26.7271Z",
    fill: "#0BCB47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0526 36.1825H46.1127C42.5882 36.1825 39.9449 35.1252 38.1239 33.0692C36.4205 31.0721 36.0093 28.6637 36.0093 26.9602V3.875H39.9449V26.9602C39.9449 30.4846 42.0009 32.3056 46.1127 32.3056H47.0526V36.1825Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0518 10.3398H32.8364V14.2168H47.0518V10.3398Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4487 10.3398H53.5718V36.1858H57.4487V10.3398Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5105 6.46149C57.2948 6.46149 58.7413 5.01504 58.7413 3.23075C58.7413 1.44646 57.2948 0 55.5105 0C53.7262 0 52.2798 1.44646 52.2798 3.23075C52.2798 5.01504 53.7262 6.46149 55.5105 6.46149Z",
    fill: "#0BCB47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1694 0H85.292V36.1844H89.1694V0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5994 36.8297C68.1393 36.8297 62.0303 30.7207 62.0303 23.2606C62.0303 15.8005 68.1393 9.69141 75.5994 9.69141C83.0598 9.69141 89.1688 15.8005 89.1688 23.2606C89.1688 30.7207 83.0598 36.8297 75.5994 36.8297ZM75.5994 13.5683C70.254 13.5683 65.9072 17.9152 65.9072 23.2606C65.9072 28.606 70.254 32.9528 75.5994 32.9528C80.9451 32.9528 85.2914 28.606 85.2914 23.2606C85.2914 17.9152 80.9451 13.5683 75.5994 13.5683Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.967 36.8297C99.5074 36.8297 93.3984 30.7207 93.3984 23.2606C93.3984 15.8005 99.5074 9.69141 106.967 9.69141C114.427 9.69141 120.537 15.8005 120.537 23.2606C120.537 30.7207 114.486 36.8297 106.967 36.8297ZM106.967 13.5683C101.622 13.5683 97.275 17.9152 97.275 23.2606C97.275 28.606 101.622 32.9528 106.967 32.9528C112.313 32.9528 116.66 28.606 116.66 23.2606C116.66 17.9152 112.313 13.5683 106.967 13.5683Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.691 36.1825H135.751C132.226 36.1825 129.583 35.1252 127.762 33.0692C126.058 31.0721 125.647 28.6637 125.647 26.9602V3.875H129.524V26.9602C129.524 30.4846 131.58 32.3056 135.692 32.3056H136.632V36.1825H136.691Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.69 10.3398H122.475V14.2168H136.69V10.3398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtidotTextWhite);
export default __webpack_public_path__ + "static/media/icon-atidot-text-white.09275f43c07e94f8c64c43b9b93b3946.svg";
export { ForwardRef as ReactComponent };